export const showNotImplementedAlert = () => {
  window.alert("Not implemented");
};
